import { render, staticRenderFns } from "./ProductAllSales.vue?vue&type=template&id=1c93fbfc&scoped=true&"
import script from "./ProductAllSales.vue?vue&type=script&lang=js&"
export * from "./ProductAllSales.vue?vue&type=script&lang=js&"
import style0 from "./ProductAllSales.vue?vue&type=style&index=0&id=1c93fbfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c93fbfc",
  null
  
)

export default component.exports